module.exports = __webpack_public_path__ + "static/media/ToniReillyPhoto.b07c8737.jpg";